'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Overlay = require('./Overlay');

var _Overlay2 = _interopRequireDefault(_Overlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Overlay2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-toolbox/lib/overlay/index.js
 ** module id = 501
 ** module chunks = 0
 **/